// extracted by mini-css-extract-plugin
export var parcelRow = "_ug-0";